// =========================================================================================@@
// Last Updated Date: Mar 28, 2022
// Last Updated By: Steven Yuen
// Status Level: 2
// ===========================================================================================

import React from 'react'
import { View } from 'oio-react'
import PropTypes from 'prop-types'
import HorizontalAdBanner from 'src/sites/custom/gns3/Banners/HorizontalAd'
import { useOrganization } from 'src/core/graphql/hooks'

const CommunityAdBanner = ({ borderRadius, marginBottom }) => {
   const { organization } = useOrganization()
   const communityAdBannerData = organization.metadata
      .find(m => m.key === 'community_ad_banner')?.value

   const {
      button_name: buttonName,
      enabled,
      message,
      url
   } = communityAdBannerData

   if (typeof communityAdBannerData !== 'object' || !enabled || !url) {
      return null
   }

   return (
      <View marginBottom={marginBottom}>
         <HorizontalAdBanner
            borderRadius={borderRadius}
            buttonName={buttonName}
            message={message}
            url={url}
         />
      </View>
   )
}

CommunityAdBanner.propTypes = {
   borderRadius: PropTypes.string,
   marginBottom: PropTypes.string
}

CommunityAdBanner.defaultProps = {
   borderRadius: undefined,
   marginBottom: '20px'
}

export default CommunityAdBanner
